import React from 'react';
import ReactDOMServer from "react-dom/server";
import { locHtml } from "../locHtml";

const DISCOUNT_ITEM = "splash.gymBuddy.togetherConsistent.checkItems.discount";
const checkItems = [
  "splash.gymBuddy.togetherConsistent.checkItems.commitment",
  "splash.gymBuddy.togetherConsistent.checkItems.billing",
  DISCOUNT_ITEM,
];

const togetherConsistent = (t: (key: string) => string) => <div className="new-quote-container centered">
  <div className="splash-icon">🤝</div>
  <div className="splash-header">
    <h1 className="no-word-break">{t("splash.gymBuddy.togetherConsistent.titleLine1")}<br/>{t("splash.gymBuddy.togetherConsistent.titleLine2")}</h1>
    <div className="quote">
      {t("splash.gymBuddy.togetherConsistent.text")}
    </div>
    <div style={{
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "400px",
      margin: "28px auto 0",
      padding: "0 36px",
    }}>
      {checkItems.map((item, idx) => (
        <div key={idx} style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          fontSize: "16px",
          color: "#1a1a1a",
          textAlign: "left",
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "#E5EEFB",
            color: "#2F6FED",
            fontSize: "16px",
            fontWeight: 700,
            flexShrink: 0,
          }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="#E7F0FF"/>
              <path d="M14.6665 6.50049L8.2498 12.9172L5.33313 10.0005" stroke="#0B6DFF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          {/* The discount line is marked so the Black Friday sale can swap in its
              copy (App.tsx, survey.onProcessHtml). */}
          <span {...(item === DISCOUNT_ITEM ? { "data-gb-discount": "" } : {})}>{t(item)}</span>
        </div>
      ))}
    </div>
  </div>
</div>;

const togetherConsistentElement = {
  name: 'togetherConsistent',
  type: 'html',
  html: locHtml((t) => ReactDOMServer.renderToStaticMarkup(togetherConsistent(t))),
  defaultValue: "true",
}

export default togetherConsistentElement;
